import classnames from 'classnames';
import { PureComponent } from 'react';

import styles from './index.module.scss';

type PropsT = {
  /** Extra classnames */
  className?: string;
  /** Is conversation closed */
  isClosed?: boolean;
  /** Does the conversation have a follow up? */
  hasFollowUp?: boolean;
  /** The conversation channel */
  channel:
    | 'adachat'
    | 'digitalgeniuschat'
    | 'kindlychat'
    | 'trustpilotreviews'
    | 'pstnphone'
    | 'email'
    | 'widgetchat'
    | 'messenger'
    | 'facebookmessenger'
    | 'whatsapp'
    | 'sms'
    | 'callback'
    | 'contactform'
    | 'voicemail'
    | 'twitter';
};

export class TimelineIcon extends PureComponent<PropsT> {
  render() {
    const { className, isClosed, channel, hasFollowUp, ...otherProps } =
      this.props;

    const rootClass = classnames(
      {
        [styles.root]: true,
        [styles.rootActive]: !isClosed,
        [styles.rootFollowUp]: hasFollowUp,
      },
      className,
    );

    return (
      <div>
        <div {...otherProps} className={rootClass}>
          <div className={styles.inner} data-channel={channel} />
        </div>
      </div>
    );
  }
}
